'use strict';

module.exports = [
    function () {

        return {
            restrict: 'E',
            scope: {
                rmSref: '@'
            },
            transclude: true,
            template: `
            <md-button
                class="rm-side-menu-button"
                layout="column"
                ng-attr-ui-sref="{{ rmSref }}"
                ui-sref-active="rm-side-menu-active"
            >
                <div layout="row" layout-fill layout-align="start center" ng-transclude></div>
            </md-button>`,
            link: function () {

            }
        };
    }
];

